/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ListItemValidationMessage,
    ListItemValidationMessageFromJSON,
    ListItemValidationMessageFromJSONTyped,
    ListItemValidationMessageToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityProviderSettingsValidationData
 */
export interface IdentityProviderSettingsValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    distributionChannel?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    agency?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    providerId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    effectiveDates?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    agencyName?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    countryDialingCode?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    phoneNumber?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    email?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    address?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    stateProvince?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    officeID?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    iataNumber?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    city?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    country?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    postalCode?: ValidationMessage;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof IdentityProviderSettingsValidationData
     */
    ticketingSettings?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    duplicateTicketingSettings?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    channelId?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    channelName?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    flxUserName?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    flxPassword?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    pcc?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    marketCode?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    marketName?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    saleCity?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    currencyCode?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    accountCode?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    agentName?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    agentPassword?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof IdentityProviderSettingsValidationData
     */
    agentRole?: ValidationMessage;
}

export function IdentityProviderSettingsValidationDataFromJSON(json: any): IdentityProviderSettingsValidationData {
    return IdentityProviderSettingsValidationDataFromJSONTyped(json, false);
}

export function IdentityProviderSettingsValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityProviderSettingsValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : ValidationMessageFromJSON(json['distributionChannel']),
        'agency': !exists(json, 'agency') ? undefined : ValidationMessageFromJSON(json['agency']),
        'providerId': !exists(json, 'providerId') ? undefined : ValidationMessageFromJSON(json['providerId']),
        'effectiveDates': !exists(json, 'effectiveDates') ? undefined : ValidationMessageFromJSON(json['effectiveDates']),
        'agencyName': !exists(json, 'agencyName') ? undefined : ValidationMessageFromJSON(json['agencyName']),
        'countryDialingCode': !exists(json, 'countryDialingCode') ? undefined : ValidationMessageFromJSON(json['countryDialingCode']),
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : ValidationMessageFromJSON(json['phoneNumber']),
        'email': !exists(json, 'email') ? undefined : ValidationMessageFromJSON(json['email']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'address': !exists(json, 'address') ? undefined : ValidationMessageFromJSON(json['address']),
        'stateProvince': !exists(json, 'stateProvince') ? undefined : ValidationMessageFromJSON(json['stateProvince']),
        'officeID': !exists(json, 'officeID') ? undefined : ValidationMessageFromJSON(json['officeID']),
        'iataNumber': !exists(json, 'iataNumber') ? undefined : ValidationMessageFromJSON(json['iataNumber']),
        'city': !exists(json, 'city') ? undefined : ValidationMessageFromJSON(json['city']),
        'country': !exists(json, 'country') ? undefined : ValidationMessageFromJSON(json['country']),
        'postalCode': !exists(json, 'postalCode') ? undefined : ValidationMessageFromJSON(json['postalCode']),
        'ticketingSettings': !exists(json, 'ticketingSettings') ? undefined : (json['ticketingSettings'] === null ? null : (json['ticketingSettings'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'duplicateTicketingSettings': !exists(json, 'duplicateTicketingSettings') ? undefined : ValidationMessageFromJSON(json['duplicateTicketingSettings']),
        'channelId': !exists(json, 'channelId') ? undefined : ValidationMessageFromJSON(json['channelId']),
        'channelName': !exists(json, 'channelName') ? undefined : ValidationMessageFromJSON(json['channelName']),
        'flxUserName': !exists(json, 'flxUserName') ? undefined : ValidationMessageFromJSON(json['flxUserName']),
        'flxPassword': !exists(json, 'flxPassword') ? undefined : ValidationMessageFromJSON(json['flxPassword']),
        'pcc': !exists(json, 'pcc') ? undefined : ValidationMessageFromJSON(json['pcc']),
        'marketCode': !exists(json, 'marketCode') ? undefined : ValidationMessageFromJSON(json['marketCode']),
        'marketName': !exists(json, 'marketName') ? undefined : ValidationMessageFromJSON(json['marketName']),
        'saleCity': !exists(json, 'saleCity') ? undefined : ValidationMessageFromJSON(json['saleCity']),
        'currencyCode': !exists(json, 'currencyCode') ? undefined : ValidationMessageFromJSON(json['currencyCode']),
        'accountCode': !exists(json, 'accountCode') ? undefined : ValidationMessageFromJSON(json['accountCode']),
        'agentName': !exists(json, 'agentName') ? undefined : ValidationMessageFromJSON(json['agentName']),
        'agentPassword': !exists(json, 'agentPassword') ? undefined : ValidationMessageFromJSON(json['agentPassword']),
        'agentRole': !exists(json, 'agentRole') ? undefined : ValidationMessageFromJSON(json['agentRole']),
    };
}

export function IdentityProviderSettingsValidationDataToJSON(value?: IdentityProviderSettingsValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'distributionChannel': ValidationMessageToJSON(value.distributionChannel),
        'agency': ValidationMessageToJSON(value.agency),
        'providerId': ValidationMessageToJSON(value.providerId),
        'effectiveDates': ValidationMessageToJSON(value.effectiveDates),
        'agencyName': ValidationMessageToJSON(value.agencyName),
        'countryDialingCode': ValidationMessageToJSON(value.countryDialingCode),
        'phoneNumber': ValidationMessageToJSON(value.phoneNumber),
        'email': ValidationMessageToJSON(value.email),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'address': ValidationMessageToJSON(value.address),
        'stateProvince': ValidationMessageToJSON(value.stateProvince),
        'officeID': ValidationMessageToJSON(value.officeID),
        'iataNumber': ValidationMessageToJSON(value.iataNumber),
        'city': ValidationMessageToJSON(value.city),
        'country': ValidationMessageToJSON(value.country),
        'postalCode': ValidationMessageToJSON(value.postalCode),
        'ticketingSettings': value.ticketingSettings === undefined ? undefined : (value.ticketingSettings === null ? null : (value.ticketingSettings as Array<any>).map(ListItemValidationMessageToJSON)),
        'duplicateTicketingSettings': ValidationMessageToJSON(value.duplicateTicketingSettings),
        'channelId': ValidationMessageToJSON(value.channelId),
        'channelName': ValidationMessageToJSON(value.channelName),
        'flxUserName': ValidationMessageToJSON(value.flxUserName),
        'flxPassword': ValidationMessageToJSON(value.flxPassword),
        'pcc': ValidationMessageToJSON(value.pcc),
        'marketCode': ValidationMessageToJSON(value.marketCode),
        'marketName': ValidationMessageToJSON(value.marketName),
        'saleCity': ValidationMessageToJSON(value.saleCity),
        'currencyCode': ValidationMessageToJSON(value.currencyCode),
        'accountCode': ValidationMessageToJSON(value.accountCode),
        'agentName': ValidationMessageToJSON(value.agentName),
        'agentPassword': ValidationMessageToJSON(value.agentPassword),
        'agentRole': ValidationMessageToJSON(value.agentRole),
    };
}


